export default function getFullName(first: string, middle: string, last: string): string {
    let name = first;
    if (middle) {
        name = name ? `${name} ${middle}.` : `${middle}.`;
    }
    if (last) {
        name = name ? `${name} ${last}` : last;
    }
    return name;
}
